<template>
    <BlogList />
</template>

<script>
import BlogList from '@/views/public/BlogList.vue'

export default {
	name: 'MainPage',
	components: {
		BlogList,
	},
	data() {
		return {
			
		}
	},
	watch: {},
	computed: {
        
	},
	methods: {
		
	},
	async beforeCreate() {
		
	},
	mounted() {
		
	}
}
</script>